import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './VisitorPage.css';
import { fetchVisitorTypesRequest } from '../../redux/actions/visitorTypeActions';

const VisitorPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Access visitor types, loading, and error from Redux state
  const { visitorTypes, loading, error } = useSelector((state) => state.visitorType);

  const colors = ["#D9B9DA", "#FAC6CC", "#F6E0BB", "#BEE8E6", "#ADC8EB"];

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    dispatch(fetchVisitorTypesRequest());
  }, [dispatch]);

  if (error) {
    return <div className="error-message">Error loading visitor types: {error.message}</div>;
  }

  if (loading) {
    return (
      <div className="loading-spinner">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!loading && visitorTypes.length === 0) {
    return <div className="no-data-message">No visitor types found. Please add some!</div>;
  }

  return (
    <div className="visitor-page">
      <h1 className="page-title">Visitor Types</h1>

      <div className="visitor-boxes">
        {visitorTypes.map((type, index) => (
          <div
            key={type.id}
            className="visitor-box"
            style={{
              backgroundColor: colors[index % colors.length],
            }}
            onClick={() => {
              localStorage.setItem("visitortype", JSON.stringify(type));
              navigate("/addVisitor");
            }}
          >
            <h3 className="visitor-type-name">{type.visitortype}</h3>
          </div>
        ))}
      </div>

      <div className="visitor-buttons">
        <button
          className="view-button"
          onClick={() => {
            if (user?.role === "SUPERADMIN") {
              navigate('/timeInVisitors');
            } else {
              navigate('/viewManagerTimeInVisitors');
            }
          }}
        >
          View Visitors
        </button>

        <button
          className="out-button"
          onClick={() => {
            if (user?.role === "SUPERADMIN") {
              navigate('/timeOutVisitors');
            } else {
              navigate('/viewManagerTimeOutVisitors');
            }
          }}
        >
          Visitors Out
        </button>
      </div>
    </div>
  );
};

export default VisitorPage;
